// Season.jsx - Migrated to Tailwind + shadcn/ui
import React from "react";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";

const Season = ({ formStates, setFormStates, setviewPrev, setviewNext, setalert }) => {
  const handleChange = (field, value) => {
    setFormStates((prev) => ({
      ...prev,
      season: { ...prev.season, [field]: value },
    }));
  };

  React.useEffect(() => {
    setviewPrev(true);
    setviewNext(true);
  }, []);

  return (
    <div className="space-y-4 p-6">
      <h2 className="text-2xl font-bold">Season Details</h2>
      
      <div>
        <Label htmlFor="season_name">Season Name</Label>
        <Input
          id="season_name"
          value={formStates.season.season_name}
          onChange={(e) => handleChange("season_name", e.target.value)}
          required
        />
      </div>

      <div>
        <Label htmlFor="description">Description</Label>
        <Input
          id="description"
          value={formStates.season.description}
          onChange={(e) => handleChange("description", e.target.value)}
        />
      </div>

      <div className="grid grid-cols-2 gap-4">
        <div>
          <Label htmlFor="start_date">Start Date</Label>
          <Input
            id="start_date"
            type="date"
            value={formStates.season.start_date}
            onChange={(e) => handleChange("start_date", e.target.value)}
            required
          />
        </div>
        <div>
          <Label htmlFor="end_date">End Date</Label>
          <Input
            id="end_date"
            type="date"
            value={formStates.season.end_date}
            onChange={(e) => handleChange("end_date", e.target.value)}
            required
          />
        </div>
      </div>
    </div>
  );
};

export { Season };
